// @flow
import _ from 'lodash';

export const dictionaryExporter = (Dictionary: Class) => {
	const {
		update,
		ready,
		data,
	} = _.bindAll(new Dictionary, [
		'update',
		'ready',
		'data',
	]);

	return {
		update,
		ready,
		data,
	};
};